<template>
  <el-dialog
    title="仓库信息"
    :visible.sync="visible"
    :close-on-click-modal="false"
    width="840px"
    append-to-body
    @closed="handleClosed">
    <el-form
      :inline="true"
      style="display:flex;justify-content: space-between;"
      @submit.native.prevent>
      <el-form-item>
      </el-form-item>
      <el-form-item>
        <ent-warehouse-auto-select
          v-model="config.warehouseNo"
          :callback="() => {handleCurrentChange(1)}" />
      </el-form-item>
    </el-form>
    <el-table
      v-loading="loading"
      border
      :data="list">
      <el-table-column
        :resizable="false"
        min-width="180"
        label="仓库名称"
        prop="warehouseName"></el-table-column>
      <el-table-column
        :resizable="false"
        label="仓库编号"
        width="80"
        prop="warehouseNo"></el-table-column>
      <!-- <el-table-column
        :resizable="false"
        label="仓库用途"
        width="90">
        <template slot-scope="{ row }">
          <span v-if="row.useType === 1">普通仓库</span>
          <span v-if="row.useType === 4">客户仓库</span>
        </template>
      </el-table-column> -->
      <el-table-column
        min-width="160"
        :resizable="false"
        label="仓库类型">
        <template slot-scope="{ row }">
          <span style="margin-right:5px;">{{ row.productType | warehouseTypeName() }}</span>
          <span v-if="row.useType === 1">【普通仓库】</span>
          <span v-if="row.useType === 4">【客户仓库】</span>
          <warehouse-setting-popover
            :id="row.warehouseId"
            :callback="fetchList"
            :productType="row.productType"
            :useType="row.useType" />
        </template>
      </el-table-column>
      <el-table-column
        min-width="240"
        :resizable="false"
        label="所属部门(公司)"
        prop="departmentName"></el-table-column>
    </el-table>
    <pagination-new
      v-model="config"
      :total="total"
      :fetch="fetchList" />
    <div slot="footer">
      <el-button @click="toggleModal(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>
<script>
import { mapState } from 'vuex'
import WarehouseSettingPopover from '../warehouse-setting-popover.vue'
import EntWarehouseAutoSelect from '@/components/business/ent-warehouse-auto-select.vue'
export default {
  name: 'WarehouseModal',
  components: { WarehouseSettingPopover, EntWarehouseAutoSelect },
  props: {
    callback: Function
  },
  data() {
    return {
      loading: false,
      list: [],
      visible: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        warehouseNo: ''
      },
      total: 0
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      userDetail: state => state.account.userDetail
    })
  },
  methods: {
    toggleModal(visible) {
      this.visible = visible
    },
    handleClosed() {
      this.list = []
      this.total = 0
      this.config.pageNum = 1
      this.config.warehouseNo = null
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList(cb) {
      this.loading = true
      this.$store.dispatch('outstock/getwarehouses', {
        payload: {
          ... this.config,
          vendorId: this.userInfo.orgId
        },
        success: res => {
          this.loading = false
          this.total = res.data.total
          this.list = res.data.records
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    fetch() {
      this.fetchList(() => {
        this.toggleModal(true)
      })
    }
  }
}
</script>
